// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OcGC7","label":"styles_label__3P_zC"};